import { useContext, useEffect, useState } from 'react';
import { CodeRepoFormCtx } from './CodeRepoFormContext';

export type InputValidation = [(i: string) => boolean, string];
export function useValidation(fieldId: string, input: string, validations: InputValidation[]) {
  // @ts-expect-error TS2339 - strict migration
  const { showValidationErrors, onInputValidation } = useContext(CodeRepoFormCtx);
  const [validationError, setValidationError] = useState<string>();

  useEffect(() => {
    const newValidationError = validations?.find((v) => v[0](input))?.[1];
    setValidationError(newValidationError);
    onInputValidation(fieldId, !!newValidationError);
  }, [input]); // eslint-disable-line react-hooks/exhaustive-deps

  return showValidationErrors && validationError;
}
